import { debounce} from 'lodash';
import {
  ChangeDetectorRef,
  Component,
  computed,
  inject,
  signal,
  viewChild
} from '@angular/core'
import { Navbar } from '../../common/navbar/navbar.component'
import {
  DatesSetInfo,
  DayInfo,
  ScheduleCalendar
} from '../../common/schedule-calendar/schedule-calendar.component'
import { EventInput } from '@fullcalendar/core'
import { TranslatePipe, TranslateService } from '@ngx-translate/core'
import { Router } from '@angular/router'
import { MyDatePipe } from '../../../pipes/date.pipe'
import { AbstractUpcomingClass } from '../../../modal/class.modal'
import { ClassService } from '../../../services/class.service'
import { ClassDetail } from '../class-detail/class-detail.component'

@Component({
  selector: 'app-schedule-portal',
  templateUrl: './schedule.component.html',
  styleUrls: ['./schedule.component.css'],
  imports: [Navbar, ScheduleCalendar, TranslatePipe, MyDatePipe, ClassDetail]
})
export class SchedulePortal {
  cdr = inject(ChangeDetectorRef)
  router = inject(Router)
  translateService = inject(TranslateService)
  classService = inject(ClassService)
  classDetailComp = viewChild(ClassDetail)
  dayInfo = signal<DayInfo>({
    date: new Date(),
    events: []
  })
  classes = signal<AbstractUpcomingClass[]>([])
  events = computed<EventInput[]>(() => {
    let list: EventInput[] = []
    this.classes().forEach((clazz) => {
      list.push({
        date: new Date(clazz.date!)
      })
    })
    return list
  })
  isLoading = signal(false)

  dayClasses = computed<AbstractUpcomingClass[]>(() => {
    let date = this.dayInfo().date
    let classes = this.classes().filter(
      (clazz) => new Date(clazz.date!).toDateString() === date.toDateString()
    )
    return classes.sort(
      (c1, c2) => c1.countDownSeconds!() - c2.countDownSeconds!()
    )
  })

  debounceGetClasses = debounce(this.getClasses, 300)

  getClasses(start: string, end: string) {
    this.isLoading.set(true)
    this.classService.getCurrentUserClasses(start, end).subscribe({
      next: (classes) => {
        this.classes.set(classes)
        this.isLoading.set(false)
      },
      error: () => this.isLoading.set(false)
    })
  }

  dayClick(info: DayInfo) {
    if (this.dayInfo().date.getTime() === info.date.getTime()) {
      return
    }
    this.dayInfo.set(info)
  }

  todayInit(info: DayInfo) {
    this.dayInfo.set(info)
  }

  datesSet(info: DatesSetInfo) {
    this.debounceGetClasses(info.start, info.end)
  }

  showClassDetail(clazz: AbstractUpcomingClass) {
    this.classDetailComp()?.show(clazz)
  }
}
